import { render, staticRenderFns } from "./BeneficiaryAutosData.vue?vue&type=template&id=d54480be&"
import script from "./BeneficiaryAutosData.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryAutosData.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryAutosData.vue?vue&type=style&index=0&id=d54480be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports